/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BoatSailingArea {
    Binnensee = 'Binnensee',
    MittelmeerNordUndOstsee = 'MittelmeerNordUndOstsee'
  }

    export const BoatSailingAreaTranslocoMap: Record<BoatSailingArea, string> = {
    [BoatSailingArea.Binnensee]: 'boatSailingArea.binnensee',
    [BoatSailingArea.MittelmeerNordUndOstsee]: 'boatSailingArea.mittelmeerNordUndOstsee',
    };

    export const BoatSailingAreaOptions = [
  { value: BoatSailingArea.Binnensee, labelKey: 'boatSailingArea.binnensee' },
  { value: BoatSailingArea.MittelmeerNordUndOstsee, labelKey: 'boatSailingArea.mittelmeerNordUndOstsee' },
    ];

